/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Remove_StudentInputs */

const en_us2_coaching_remove_student = /** @type {(inputs: Coaching_Remove_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from group`)
};

const pt_br2_coaching_remove_student = /** @type {(inputs: Coaching_Remove_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover da turma`)
};

const pt_pt2_coaching_remove_student = /** @type {(inputs: Coaching_Remove_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover da turma`)
};

/** @type {(inputs: Coaching_Remove_StudentInputs) => LocalizedString} */
const es_419_coaching_remove_student = en_us2_coaching_remove_student;

/** @type {(inputs: Coaching_Remove_StudentInputs) => LocalizedString} */
const fr_fr2_coaching_remove_student = en_us2_coaching_remove_student;

/** @type {(inputs: Coaching_Remove_StudentInputs) => LocalizedString} */
const de_de2_coaching_remove_student = en_us2_coaching_remove_student;

/** @type {(inputs: Coaching_Remove_StudentInputs) => LocalizedString} */
const it_it2_coaching_remove_student = en_us2_coaching_remove_student;

/**
* | output |
* | --- |
* | "Remove from group" |
*
* @param {Coaching_Remove_StudentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_remove_student = /** @type {((inputs?: Coaching_Remove_StudentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Remove_StudentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_remove_student(inputs)
	if (locale === "es-419") return es_419_coaching_remove_student(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_remove_student(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_remove_student(inputs)
	if (locale === "de-DE") return de_de2_coaching_remove_student(inputs)
	if (locale === "it-IT") return it_it2_coaching_remove_student(inputs)
	return en_us2_coaching_remove_student(inputs)
});
export { coaching_remove_student as "coaching.remove_student" }